module.exports = __webpack_public_path__ + "static/media/of_estandar.b1584c46.png";